<template>
  <button
    v-if="created === false"
    type="button"
    class="relative inline-flex items-center px-4 py-2 border text-sm font-medium rounded-md bg-white focus:outline-none border-gray-300 text-gray-700 hover:bg-gray-50 focus:border-blue-600"
    @click="createSavedQuery"
  >
    <span>Save</span>
  </button>
</template>

<script>
import { accountContactSavedQueriesClient } from '@/api/clients';

export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
    query: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      created: false,
    };
  },
  watch: {
    query: {
      handler() {
        this.created = false;
      },
      deep: true,
    },
  },
  methods: {
    async store(data) {
      try {
        const response = await accountContactSavedQueriesClient.store(this.accountId, data);

        this.$emit('created', response.data.data);
        this.created = true;

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    createSavedQuery() {
      this.$modal.show({
        component: () => import('Components/SavedQueries/CreateSavedQueryModal.vue'),
        props: {
          action: this.store,
          query: this.query,
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
